import { z } from 'zod'

import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const FAILURE_IMAGE_SRC =
  'https://cdn.sanity.io/images/p4gom3ch/production/0de353a55462635c64b09ddc7843b932193fe47b-624x698.png'

export const buildFailureStep = (i18nNamespace: string): AnyStepConfiguration =>
  ({
    schema: z.object({}),
    stepContent: [
      {
        type: 'spacer',
        size: 'xlarge',
      },
      {
        type: 'image',
        src: FAILURE_IMAGE_SRC,
        width: 205,
        height: 205,
        align: 'center',
        useURI: true,
        contentFit: 'contain',
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: `${i18nNamespace}:steps.landing_failure.title`,
        },
        align: 'center',
        size: 'h3',
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: `${i18nNamespace}:steps.landing_failure.body`,
        },
        align: 'center',
        style: 'body1',
      },
    ],
    buttonLabel: {
      type: 'translatableText',
      translationKey: `${i18nNamespace}:steps.landing_failure.done`,
    },
    subFlow: SubFlow.PaymentAndConfirmation,
    hideBackButton: true,
  }) as AnyStepConfiguration
export const buildSuccessStep = (): AnyStepConfiguration => ({
  schema: z.object({}).passthrough(),
  stepContent: [
    {
      type: 'customComponent',
      name: 'FlowSuccess',
      inputs: [],
      outputs: [],
      props: {},
    },
  ],
  subFlow: SubFlow.PaymentAndConfirmation,
  hideBackButton: true,
  footer: { hideFooter: true },
})

export const buildProgressBarSections = ({
  insuranceSubFlow,
  i18nNamespace,
}: {
  insuranceSubFlow: SubFlow
  i18nNamespace: string
}) => [
  {
    name: insuranceSubFlow,
    type: 'insurance' as const,
    number: 1,
    label: `${i18nNamespace}:progressBar.insurance`,
  },
  {
    name: SubFlow.Common,
    type: 'personalDetails' as const,
    number: 2,
    label: `${i18nNamespace}:progressBar.personalDetails`,
  },
  {
    name: SubFlow.PaymentAndConfirmation,
    type: 'paymentAndConfirmation' as const,
    number: 3,
    label: `${i18nNamespace}:progressBar.paymentAndConfirmation`,
  },
]

export const buildAlreadyPurchasedStep = (): AnyStepConfiguration => ({
  schema: z.object({}).passthrough(),
  stepContent: [
    {
      type: 'title',
      text: {
        type: 'translatableText',
        translationKey: 'sharedFlows_common:steps.already_purchased.title',
      },
      align: 'center',
    },
    {
      type: 'text',
      text: {
        type: 'translatableText',
        translationKey: 'sharedFlows_common:steps.already_purchased.description',
      },
      align: 'center',
    },
  ],
  subFlow: SubFlow.Common,
  isFailureStep: true,
  hideBackButton: true,
  footer: { hideFooter: true },
})
